import React, { ReactNode } from 'react';
import './Menu.css';
import withTheme from '../../../hocs/withTheme';

function Menu({
    children = null, className = '', ...rest
}: {children?: ReactNode; className?: string;}) {
    return (
        <ul
            {...rest}
            className={`Menu ${className}`}
            role="menu"
        >
            {children}
        </ul>
    );
}

export default withTheme(Menu);
